import React, { memo, useCallback } from "react";
import { Typography, Link } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Dialog, Button } from "@shared/components";
import { useAppDispatch, useAppSelector } from "@app/hooks";
import { closeAccessDeniedDialog } from "@app/store/accessDeniedDucks";

const useStyles = makeStyles((theme) => ({
  bodyText: {
    fontSize: 18,
    lineHeight: 1.6,
    color: theme.palette.primary.main,
  },
  emailLink: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    textDecoration: "underline",
    "&:hover": {
      color: theme.palette.info.main,
    },
  },
}));

const AccessDeniedDialog = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const open = useAppSelector((state) => state.accessDenied.open);

  const handleClose = useCallback(
    ({ reason }: { reason: string }) => {
      // Ignore history-change close events triggered by ProfileRouteGuard redirect
      if (reason === "historyChange") return;
      dispatch(closeAccessDeniedDialog());
    },
    [dispatch]
  );

  const handleCloseButtonClick = useCallback(() => {
    dispatch(closeAccessDeniedDialog());
  }, [dispatch]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      title="ACCESS DENIED"
      maxWidth="md"
      fullWidth
      actions={
        <Button
          shape="rounded"
          variant="outlined"
          size="medium"
          onClick={handleCloseButtonClick}
          testId="access-denied-close"
        >
          CLOSE
        </Button>
      }
    >
      <Typography className={classes.bodyText} data-testid="access-denied-body">
        You do not have access to My Profile. If you believe you should have access, please contact{" "}
        <Link
          href="mailto:investor.services@carlyle.com"
          className={classes.emailLink}
          data-testid="access-denied-email-link"
        >
          investor.services@carlyle.com
        </Link>
        .
      </Typography>
    </Dialog>
  );
};

export default memo(AccessDeniedDialog);
